module.exports = __webpack_public_path__ + "img/formula.11ddd426.svg";